import { rem, bokeh, keyframes } from '@vimeo/bokeh';

import { EXPANDED_SEARCH_WIDTH } from '../styles';

const expandInput = keyframes`
  from {
    width: ${rem(35)};
    opacity: 0;
  }

  to {
    max-width: ${rem(EXPANDED_SEARCH_WIDTH)};
    width: 100%;
    opacity: 1;
  }
`;

export const InputWrapper = bokeh('div', {
  baseStyle: {
    top: '50%',
    maxW: '80vw',
    zIndex: 3,
    animation: `${expandInput} 250ms ease forwards`,
    'input, select': {
      height: '40px',
    },
    '[aria-busy=true]': {
      animation: `${expandInput} 250ms ease forwards`,
      right: 0,
    },
    /**
     * Since we apply an animation to this component backdrop-filter blur doesnt work as expected
     * and we end up with a see through background.
     * So we apply a background color without the opacity ( background token ).
     */
    '.search-menu': {
      bgColor: 'fill-surface !important',
    },
  },
});
